import { render, staticRenderFns } from "./cases.vue?vue&type=template&id=78511248&"
import script from "./cases.vue?vue&type=script&lang=js&"
export * from "./cases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports